module.exports = __webpack_public_path__ + "static/media/ryad.9c3e1738.png";